import { GraphQLCompletionRequester } from '@cobliteam/api-lib';
import type { CompletionData } from '@cobliteam/api-lib/src/__generated__/graphql';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

const QUERY_KEY = 'COMPLETION_DATA';

type UseCompletionDataParams = {
  options?: Partial<UseQueryOptions<CompletionData | null>>;
};

const requester = new GraphQLCompletionRequester();

const useCompletionData = (params?: UseCompletionDataParams) => {
  return useQuery<CompletionData | null>({
    ...params?.options,
    queryKey: [QUERY_KEY],
    queryFn: () => requester.getCompletionData(),
  });
};

export { useCompletionData, QUERY_KEY };
export default useCompletionData;
